module.exports = __webpack_public_path__ + "static/media/view staff leave.42263314.svg";